import { types } from "../types/types";

const initialState = {
  companiesOptions: [], // Aquí guardaremos las opciones del dropdown
  selectedCompanies: [] // Opcional: si quieres manejar las selecciones en Redux
};

export const companiesHoldingReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.setCompaniesHoldingOptions:
      return {
        ...state,
        companiesOptions: action.payload
      };
    case types.setSelectedCompanies:
      return {
        ...state,
        selectedCompanies: action.payload
      };
    default:
      return state;
  }
};